// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__37IF5","list":"PatternAutocomplete_list__1W_EA"};